import * as React from 'react';
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15.002} height={15.105} {...props}>
    <g data-name="Phone 15">
      <path
        fill="#fed400"
        d="m14.674 11.92-2.257-2.258a1.178 1.178 0 0 0-1.66.032L9.619 10.83l-.224-.125a11.314 11.314 0 0 1-2.736-1.978 11.382 11.382 0 0 1-1.982-2.741l-.122-.219.763-.762.375-.376a1.176 1.176 0 0 0 .03-1.66L3.465.71a1.176 1.176 0 0 0-1.66.031l-.636.64.018.017a3.669 3.669 0 0 0-.524.922 3.839 3.839 0 0 0-.234.938c-.3 2.471.832 4.73 3.9 7.795 4.237 4.236 7.651 3.916 7.8 3.9a3.824 3.824 0 0 0 .941-.236 3.668 3.668 0 0 0 .921-.522l.014.012.645-.631a1.178 1.178 0 0 0 .03-1.661"
        data-name="Phone 19"
      />
      <path
        fill="#feda00"
        d="M9.499 14.513a14.077 14.077 0 0 1-5.173-3.458C1.26 7.991.131 5.732.429 3.261a3.833 3.833 0 0 1 .234-.938 3.649 3.649 0 0 1 .52-.925l-.014-.016.637-.64a1.208 1.208 0 0 1 .858-.36 1.123 1.123 0 0 1 .8.327l2.259 2.259a1.176 1.176 0 0 1-.03 1.66l-.375.376-.763.762.087.155.036.064a11.372 11.372 0 0 0 1.98 2.736 10.263 10.263 0 0 0 1.84 1.461l1 4.33Z"
        data-name="Path 10435"
      />
      <path
        fill="rgba(0,0,0,0)"
        d="m10.026 15.105-.657-.232a14.451 14.451 0 0 1-5.315-3.548C.9 8.167-.265 5.818.049 3.215A4.2 4.2 0 0 1 .3 2.187a4.113 4.113 0 0 1 .385-.745l-.059-.058.908-.913A1.588 1.588 0 0 1 2.663 0a1.5 1.5 0 0 1 1.071.439L5.992 2.7a1.559 1.559 0 0 1-.03 2.2l-.935.934a10.972 10.972 0 0 0 1.9 2.624A9.887 9.887 0 0 0 8.7 9.859l.134.084ZM1.6 1.487l-.115.146a3.268 3.268 0 0 0-.469.828 3.449 3.449 0 0 0-.21.842c-.282 2.343.815 4.51 3.787 7.481a14.4 14.4 0 0 0 4.368 3.108l-.8-3.472a10.588 10.588 0 0 1-1.774-1.425 11.706 11.706 0 0 1-2.043-2.82l-.038-.069-.085-.151-.144-.255 1.344-1.343a.794.794 0 0 0 .03-1.12L3.194.979a.743.743 0 0 0-.531-.215.828.828 0 0 0-.588.247Z"
        data-name="Path 10435 - Outline"
      />
    </g>
  </svg>
);
export default SvgComponent;
